import { FeatureFlag } from '../FeatureFlag';

/**
 * Shows the firm Overview page under `/admin/firms/:firmId/overview` and the cross-firm LAB
 * Routing page under `/admin/lab/routing`. Both read live admin queries; the flag gates their
 * rollout. See `docs/admin-firm-overview.md`.
 */
export const enableAdminFirmOverview = new FeatureFlag({
    key: 'enable-admin-firm-overview',
    defaultValue: false,
});
